import DialogActions from '@mui/material/DialogActions';
import type { DialogActionsProps } from '@mui/material/DialogActions';

const MUIDialogActions = (props: DialogActionsProps) => {
  return <DialogActions data-testid="test-dialog-actions" {...props} />;
};

export default MUIDialogActions;
